export * from './src/pipe.module';
